const fingoStepsContainer = {
  padding: { xs: '3rem 2rem', s: '3rem 3rem', md: '3rem 6rem' },
  gap: { xs: '3rem', phone: '5rem' },
  color: 'white',
  background: 'radial-gradient(50% 58% at 60% bottom, rgba(230, 46, 102, 0.41) 0%, rgba(230, 46, 102, 0.00) 100%)',
  width: '100%',
};

const titleTypography = (theme) => ({
  color: theme.palette.neutral.A800,
  textAlign: 'center',
});

const subtitleTypography = (theme) => ({
  color: theme.palette.neutral.A700,
  textAlign: 'center',
});

const stepperContainer = {
  flexDirection: 'row',
  width: '100%',
  maxWidth: '80rem',
  alignItems: 'center',
  justifyContent: 'center',
};

const stepperContent = {
  display: 'flex',
  flexDirection: { smartphone: 'column', m: 'row' },
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '1.5rem',
  flex: '1 0 0',
};

const stepCard = {
  minHeight: '18.75rem',
  height: '100%',
  width: '100%',
  overflow: 'hidden',
  borderRadius: '1rem',
  position: 'relative',
};

const stepImageContainer = (stepId, activeStepId) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  transition: 'transform 0.6s ease-out',
  transform: stepId <= activeStepId ? 'translateX(0%)' : 'translateX(100%)',
  zIndex: activeStepId === stepId ? 2 : 1,
});

const stepImage = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: '1rem',
};

const stepOverlay = {
  position: 'absolute',
  bottom: '0',
  left: '0',
  right: '0',
  backgroundColor: 'transparent',
  borderRadius: '0.5rem',
  padding: '2rem',
  zIndex: 3,
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  alignItems: 'flex-start',
  background: 'linear-gradient(180deg, rgba(24, 40, 77, 0.00) 0%, #18284D 100%)',
};

const stepTypography = {
  textAlign: 'flex-start',
  width: { xs: '100%', phone: '60%' },
};

export {
  fingoStepsContainer,
  titleTypography,
  subtitleTypography,
  stepperContainer,
  stepperContent,
  stepCard,
  stepImageContainer,
  stepImage,
  stepOverlay,
  stepTypography,
};
